import { render } from "./BuildingTypeDetail.vue?vue&type=template&id=ede1739a&scoped=true"
import script from "./BuildingTypeDetail.vue?vue&type=script&lang=js"
export * from "./BuildingTypeDetail.vue?vue&type=script&lang=js"

import "./BuildingTypeDetail.vue?vue&type=style&index=0&id=ede1739a&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede1739a"]])

export default __exports__